import React, { useState } from "react";
import { PrintRecord } from "../../../BlakeData/Types";
import PrintDetails from "./PrintDetails";
import "./style/DetailedMetaData.scss";
import "./style/RoomyDetails.scss";

import { ReactComponent as CloseIcon } from "./close-icon.svg";
import { ReactComponent as InfoIcon } from "./info_gray.svg";

function RoomyDetails(props: {
    print: PrintRecord | null;
    side: "left" | "right" | null;
    maxWidth: number;
}) {
    return (
        <div className={`RoomyDetails ${props.print ? "" : "empty"}`}
            style={{
                // height:`${props.maxWidth}px`,
                flex: `0 0 ${props.maxWidth}px`
                // flex:`300px 0 ${props.maxWidth}px`
            }}>
            {props.print ? <PrintDetails print={props.print} /> : null}
        </div>
    )
}

function RoomyFiller(props: { width: number }) {
    return (
        <div className="RoomyFiller"
            style={{ flex: `0 0 ${props.width}px` }}
        ></div>
    )
}

/**
 * Detailed meta data for an arbitrary number of prints (usually 0, 1, or 2)
 * @param props 
 */
export default function DetailedMetadata(props: {
    imageWidth: number;
    width: number;
    prints: Array<PrintRecord>
}) {

    const roomyBoxWidth = 250;
    const roomyBoxGutter = 20;
    const [collapsed, setCollapsed] = useState<boolean>(true);
    const roomy = (props.width - props.imageWidth) > (roomyBoxGutter * 4 + roomyBoxWidth * 2)

    // if (roomy) { console.log("Wow, so roomy") }

    if (props.width === 0){ return (null)}

    const leftPrint = props.prints.length > 0 ? props.prints[0] : null;
    const rightPrint = props.prints.length > 1 ? props.prints[1] : null;

    const leftText = <RoomyDetails maxWidth={roomyBoxWidth} side="left" print={leftPrint} />;
    const rightText = <RoomyDetails maxWidth={roomyBoxWidth} side="right" print={rightPrint} />;

    if (roomy) {
        return (<div className="roomy-container"
            style={{
                // bottom:`${roomyBoxWidth - roomyBoxGutter}px`,
                // left:`${roomyBoxGutter}px`,
                // right:`${roomyBoxGutter}px`,
            }}>
            {leftText}
            <RoomyFiller width={props.imageWidth} />
            {rightText}
        </div>)
    }

    const condensedText = (side: "left" | "right", print: PrintRecord | null) => {
        if (!print) { return (null) }
        return <PrintDetails
            position={props.prints.length > 1 ? side + ": " : ""}
            print={print}></PrintDetails>
    }

    return (
        <div className={`DetailedMetadata ${collapsed ? "collapsed" : (null)}`}>
            <div onClick={() => { setCollapsed(!collapsed) }}>
                <div className="control-button">
                    {collapsed ? <InfoIcon/> : <CloseIcon/>}
                </div>
            </div>
            {/* {leftText}
            {rightText} */}
            <div>
                {collapsed ? (null) :
                    [condensedText("left", leftPrint),
                    condensedText("right", rightPrint)]
                }
            </div>
        </div>
    )

}